import { Module } from "vuex";
import { State } from "@/store/modules/logo/state";
import Mutations from "@/store/modules/logo/mutations";
import Getters from "@/store/modules/logo/getters";
import Actions from "@/store/modules/logo/actions";

export class Logo implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
